import { useState, type ComponentProps, type ReactNode } from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetFooter,
} from '@/components/ui/sheet';
import { AppDialog } from './AppDialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description: string;
  children: ReactNode;
  footer: ReactNode;
  bodyKey?: string;
  onCloseAutoFocus?: ComponentProps<typeof SheetContent>['onCloseAutoFocus'];
}

/** 호출부는 열 때 key를 갱신한다. 열린 동안 형태를 고정해 폭 변경으로 초점 가두기를 재생성하지 않는다. */
export function AppResponsiveDialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  bodyKey,
  onCloseAutoFocus,
}: Props) {
  const [mobile] = useState(() => window.matchMedia('(max-width: 767px)').matches);
  const overlayClassName = 'duration-200 motion-reduce:animate-none motion-reduce:transition-none';
  const contentClassName =
    '[&>button]:top-2 [&>button]:right-2 [&>button]:size-11 flex max-h-[85dvh] flex-col overflow-hidden duration-200 data-[state=open]:duration-200 data-[state=closed]:duration-200 motion-reduce:animate-none motion-reduce:transition-none';
  const body = (
    <div key={bodyKey} className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
      {children}
    </div>
  );
  if (mobile) {
    return (
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent
          side="bottom"
          className={contentClassName}
          overlayClassName={overlayClassName}
          onCloseAutoFocus={onCloseAutoFocus}
        >
          <SheetHeader className="shrink-0 pr-6 text-left">
            <SheetTitle>{title}</SheetTitle>
            <SheetDescription>{description}</SheetDescription>
          </SheetHeader>
          {body}
          <SheetFooter className="shrink-0">{footer}</SheetFooter>
        </SheetContent>
      </Sheet>
    );
  }
  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      footer={footer}
      size="lg"
      className={`${contentClassName} w-[calc(100%-2rem)]`}
      overlayClassName={overlayClassName}
      onCloseAutoFocus={onCloseAutoFocus}
    >
      {body}
    </AppDialog>
  );
}
